import { useEffect } from "react";

import "vanilla-cookieconsent/dist/cookieconsent.css";
import * as CookieConsent from "vanilla-cookieconsent";

export default function CookieConsentComponent({locale}) {
  useEffect(() => {
    CookieConsent.run({
      categories: {
        necessary: {
          enabled: true,
          readOnly: true,
        },
        analytics: {
          enabled: true,
          readOnly: false,
        }
      },

      language: {
        default: locale,
        translations: {
          es: {
            consentModal: {
              description:
                "Este sitio web utiliza cookies que pueden ser activadas o desactivadas.",
              acceptAllBtn: "Aceptar",
              acceptNecessaryBtn: "Rechazar",
              showPreferencesBtn: "Gestionar preferencias",
              footer: `<a href="/es/terms-and-conditions">Términos y Condiciones</a> <a href="/es/privacy-policy">Política de Privacidad</a>`,
            },
            preferencesModal: {
              title: "Configurar preferencias",
              acceptAllBtn: "Aceptar",
              acceptNecessaryBtn: "Rechazar",
              savePreferencesBtn: "Guardar cambios",
              closeIconLabel: "Cerrar",
              sections: [
                {
                  description:
                    "Elige las cookies que autorizas a Petrotec a utilizar:",
                },
                {
                  title: "Cookies Funcionales",
                  description:
                    "Se utilizan para funcionalidades esenciales para el correcto funcionamiento del sitio web.",
                  linkedCategory: "necessary",
                  cookieTable: {
                    headers: {
                      name: "Nombre",
                      domain: "Servicio",
                      description: "Descripción",
                      expiration: "Expiración",
                    },
                    body: [
                      {
                        name: "cc_cookie",
                        domain: "petrotecgroup.es",
                        description:
                          "Almacena la información sobre la selección de cookies del usuario.",
                        expiration: "6 meses",
                      },
                      {
                        name: "NEXT_LOCALE",
                        domain: "petrotecgroup.es",
                        description:
                          "Recoge la información del idioma seleccionado por el usuario.",
                        expiration: "Sesión",
                      }
                    ],
                  },
                },
                {
                  title: "Análisis y Estadísticas",
                  description:
                    "Se utilizan para crear y analizar información estadística para mejorar el funcionamiento y los contenidos del sitio.",
                  linkedCategory: "analytics",
                  cookieTable: {
                    headers: {
                      name: "Nombre",
                      domain: "Servicio",
                      description: "Descripción",
                      expiration: "Expiración",
                    },
                    body: [
                      {
                        name: "_ga",
                        domain: "google.com",
                        description:
                          "Recoge estadísticas sobre el uso del sitio web; específicamente, la fuente del tráfico, las páginas visitadas, la duración de la sesión, entre otros.",
                        expiration: "13 meses",
                      },
                      {
                        name: "_ga_CHKDJSNW0F",
                        domain: "google.com",
                        description:
                          "Rastrea el número de veces que un usuario ha visitado el sitio, así como las fechas de la primera y última visita.",
                        expiration: "13 meses",
                      },
                    ],
                  },
                }
              ],
            },
          },
          pt: {
            consentModal: {
              description:
                "Este website utiliza cookies que podem ser activados ou desativados.",
              acceptAllBtn: "Aceitar",
              acceptNecessaryBtn: "Rejeitar",
              showPreferencesBtn: "Gerir preferências",
              footer: `<a href="/pt/terms-and-conditions">Termos e Condições</a> <a href="/pt/privacy-policy">Protecção de dados pessoais</a>`,
            },
            preferencesModal: {
              title: "Definir preferências",
              acceptAllBtn: "Aceitar",
              acceptNecessaryBtn: "Rejeitar",
              savePreferencesBtn: "Guardar alterações",
              closeIconLabel: "Fechar",
              sections: [
                {
                  description:
                    "Escolha os cookies que autoriza a Petrotec a utilizar:",
                },
                {
                  title: "Cookies Funcionais",
                  description:
                    "São utilizados para funcionalidades essenciais para o bom funcionamento do website.",
                  linkedCategory: "necessary",
                  cookieTable: {
                    headers: {
                      name: "Nome",
                      domain: "Serviço",
                      description: "Descrição",
                      expiration: "Validade",
                    },
                    body: [
                      {
                        name: "cc_cookie",
                        domain: "petrotec.com",
                        description:
                          "Armazena a informação sobre a selecção de cookies do utilizador.",
                        expiration: "6 months",
                      },
                      {
                        name: "NEXT_LOCALE",
                        domain: "petrotec.com",
                        description:
                          "Recolhe a informação do idioma seleccionado pelo utilizador.",
                        expiration: "Sessão",
                      }
                    ],
                  },
                },
                {
                  title: "Análise e Estatística",
                  description:
                    "São utilizados para fins de criação e análise de informação estatística, a fim de melhorar o funcionamento e os conteúdos do site.",
                  linkedCategory: "analytics",
                  cookieTable: {
                    headers: {
                      name: "Nome",
                      domain: "Serviço",
                      description: "Descrição",
                      expiration: "Validade",
                    },
                    body: [
                      {
                        name: "_ga",
                        domain: "google.com",
                        description:
                          "Recolhe estatísticas acerca da utilização do website; mais especificamente, a origem do tráfego, as páginas visitadas, o tempo de sessão, entre outros.",
                        expiration: "13 meses",
                      },
                      {
                        name: "_ga_CHKDJSNW0F",
                        domain: "google.com",
                        description:
                          "Rastreia o número de vezes que um utilizador visitou o site, bem como as datas da primeira e última visita.",
                        expiration: "13 meses",
                      },
                    ],
                  },
                }
              ],
            },
          },
          de: {
            consentModal: {
              description:
                "Diese Website verwendet Cookies, die aktiviert oder deaktiviert werden können.",
              acceptAllBtn: "Akzeptieren",
              acceptNecessaryBtn: "Ablehnen",
              showPreferencesBtn: "Präferenzen verwalten",
              footer: `<a href="/de/terms-and-conditions">Allgemeine Geschäftsbedingungen</a> <a href="/de/privacy-policy">Datenschutzrichtlinie</a>`,
            },
            preferencesModal: {
              title: "Präferenzen festlegen",
              acceptAllBtn: "Akzeptieren",
              acceptNecessaryBtn: "Ablehnen",
              savePreferencesBtn: "Änderungen speichern",
              closeIconLabel: "Schließen",
              sections: [
                {
                  description:
                    "Wählen Sie die Cookies aus, die Sie Petrotec erlauben zu verwenden:",
                },
                {
                  title: "Funktionale Cookies",
                  description:
                    "Diese werden für essenzielle Funktionen verwendet, die für den ordnungsgemäßen Betrieb der Website erforderlich sind.",
                  linkedCategory: "necessary",
                  cookieTable: {
                    headers: {
                      name: "Name",
                      domain: "Dienst",
                      description: "Beschreibung",
                      expiration: "Ablauf",
                    },
                    body: [
                      {
                        name: "cc_cookie",
                        domain: "petrotecgroup.de",
                        description:
                          "Speichert Informationen über die Cookie-Auswahl des Benutzers.",
                        expiration: "6 Monate",
                      },
                      {
                        name: "NEXT_LOCALE",
                        domain: "petrotecgroup.de",
                        description:
                          "Erfasst Informationen über die vom Benutzer ausgewählte Sprache.",
                        expiration: "Sitzung",
                      }
                    ],
                  },
                },
                {
                  title: "Analyse und Statistik",
                  description:
                    "Diese werden verwendet, um statistische Informationen zu erstellen und zu analysieren, um die Funktionalität und Inhalte der Website zu verbessern.",
                  linkedCategory: "analytics",
                  cookieTable: {
                    headers: {
                      name: "Name",
                      domain: "Dienst",
                      description: "Beschreibung",
                      expiration: "Ablauf",
                    },
                    body: [
                      {
                        name: "_ga",
                        domain: "google.com",
                        description:
                          "Erfasst Statistiken über die Nutzung der Website; insbesondere die Herkunft des Traffics, besuchte Seiten, Sitzungsdauer und mehr.",
                        expiration: "13 Monate",
                      },
                      {
                        name: "_ga_CHKDJSNW0F",
                        domain: "google.com",
                        description:
                          "Verfolgt die Anzahl der Besuche eines Benutzers auf der Website sowie die Daten des ersten und letzten Besuchs.",
                        expiration: "13 Monate",
                      },
                    ],
                  },
                }
              ],
            },
          },
          fr: {
            consentModal: {
              description:
                "Ce site web utilise des cookies qui peuvent être activés ou désactivés.",
              acceptAllBtn: "Accepter",
              acceptNecessaryBtn: "Refuser",
              showPreferencesBtn: "Gérer les préférences",
              footer: `<a href="/fr/terms-and-conditions">Conditions générales</a> <a href="/fr/privacy-policy">Politique de confidentialité</a>`,
            },
            preferencesModal: {
              title: "Définir les préférences",
              acceptAllBtn: "Accepter",
              acceptNecessaryBtn: "Refuser",
              savePreferencesBtn: "Enregistrer les modifications",
              closeIconLabel: "Fermer",
              sections: [
                {
                  description:
                    "Choisissez les cookies que vous autorisez Petrotec à utiliser :",
                },
                {
                  title: "Cookies fonctionnels",
                  description:
                    "Ils sont utilisés pour des fonctionnalités essentielles au bon fonctionnement du site web.",
                  linkedCategory: "necessary",
                  cookieTable: {
                    headers: {
                      name: "Nom",
                      domain: "Service",
                      description: "Description",
                      expiration: "Expiration",
                    },
                    body: [
                      {
                        name: "cc_cookie",
                        domain: "petrotecgroup.fr",
                        description:
                          "Stocke les informations sur les préférences de cookies de l'utilisateur.",
                        expiration: "6 mois",
                      },
                      {
                        name: "NEXT_LOCALE",
                        domain: "petrotecgroup.fr",
                        description:
                          "Collecte les informations sur la langue sélectionnée par l'utilisateur.",
                        expiration: "Session",
                      }
                    ],
                  },
                },
                {
                  title: "Analyse et Statistiques",
                  description:
                    "Ils sont utilisés pour créer et analyser des informations statistiques afin d'améliorer le fonctionnement et le contenu du site.",
                  linkedCategory: "analytics",
                  cookieTable: {
                    headers: {
                      name: "Nom",
                      domain: "Service",
                      description: "Description",
                      expiration: "Expiration",
                    },
                    body: [
                      {
                        name: "_ga",
                        domain: "google.com",
                        description:
                          "Collecte des statistiques sur l'utilisation du site web ; notamment la source du trafic, les pages visitées, la durée des sessions, entre autres.",
                        expiration: "13 mois",
                      },
                      {
                        name: "_ga_CHKDJSNW0F",
                        domain: "google.com",
                        description:
                          "Suit le nombre de fois qu'un utilisateur a visité le site, ainsi que les dates de la première et de la dernière visite.",
                        expiration: "13 mois",
                      },
                    ],
                  },
                }
              ],
            },
          },          
          en: {
            consentModal: {
              description:
                "This website uses cookies that can be activated or deactivated.",
              acceptAllBtn: "Accept",
              acceptNecessaryBtn: "Reject",
              showPreferencesBtn: "Manage preferences",
              footer: `<a href="/terms-and-conditions">Terms and Conditions</a> <a href="/privacy-policy">Privacy Policy</a>`,
            },
            preferencesModal: {
              title: "Set preferences",
              acceptAllBtn: "Accept",
              acceptNecessaryBtn: "Reject",
              savePreferencesBtn: "Save changes",
              closeIconLabel: "Close",
              sections: [
                {
                  description:
                    "Choose the cookies you authorize Petrotec to use:",
                },
                {
                  title: "Functional Cookies",
                  description:
                    "These are used for essential functionalities for the proper operation of the website.",
                  linkedCategory: "necessary",
                  cookieTable: {
                    headers: {
                      name: "Name",
                      domain: "Service",
                      description: "Description",
                      expiration: "Expiration",
                    },
                    body: [
                      {
                        name: "cc_cookie",
                        domain: "petrotec.com",
                        description:
                          "Collects the cookies preferences selected by the user.",
                        expiration: "6 months",
                      },
                      {
                        name: "NEXT_LOCALE",
                        domain: "petrotec.com",
                        description:
                          "Collects information about the language selected by the user.",
                        expiration: "Session",
                      }
                    ],
                  },
                },
                {
                  title: "Analysis and Statistics",
                  description:
                    "These are used for creating and analyzing statistical information to improve the functioning and content of the site.",
                  linkedCategory: "analytics",
                  cookieTable: {
                    headers: {
                      name: "Name",
                      domain: "Service",
                      description: "Description",
                      expiration: "Expiration",
                    },
                    body: [
                      {
                        name: "_ga",
                        domain: "google.com",
                        description:
                          "Collects statistics about website usage; specifically, traffic source, pages visited, session duration, among others.",
                        expiration: "13 months",
                      },
                      {
                        name: "_ga_CHKDJSNW0F",
                        domain: "google.com",
                        description:
                          "Tracks the number of times a user has visited the site, as well as the dates of the first and last visit.",
                        expiration: "13 months",
                      },
                    ],
                  },
                }
              ],
            },
          },
        },
      },

      guiOptions: {
        consentModal: {
          layout: "box wide",
          position: "bottom left",
          flipButtons: false,
          equalWeightButtons: false,
        },
        preferencesModal: {
          layout: "box",
          flipButtons: false,
          equalWeightButtons: false,
        },
      },
    });
    CookieConsent.setLanguage(locale)
  }, [locale]);
}
